import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import { useFacebookPageAnalyticsPostQuery, useInfluencerFacebookPageAnalyticsPostQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'influencerId' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
  isAnalytics?: boolean;
}

export const Template = ({ className, isAnalytics }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInfluencerFacebookPageAnalyticsPostQuery({
    skip: !selectedPost?.id || !selectedPost?.influencerId || !selectedPost?.mainSocialAccountId || isAnalytics,
    variables: {
      postId: Number(selectedPost?.id),
      socialAccountId: Number(selectedPost?.mainSocialAccountId),
      influencerId: Number(selectedPost?.influencerId)
    },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });
  const { data: analyticsData, loading: fetchingAnalyticsData } = useFacebookPageAnalyticsPostQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || !isAnalytics,
    variables: {
      facebookPageAnalyticsPostId: Number(selectedPost?.id),
      facebookPageAnalyticsAccountId: Number(selectedPost?.mainSocialAccountId)
    },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.influencerFacebookPageAnalyticsPost || analyticsData?.facebookPageAnalyticsPost;

  return (
    <PostModal.DetailsTemplate
      className={className}
      loading={loading || fetchingAnalyticsData}
      data={
        details
          ? {
              socialMedia: 'FACEBOOK_PAGE',
              postUrl: details?.postUrl,
              caption: details?.content,
              postDate: details?.postDate,
              images: details?.image ? [details.image] : [],
              comments:
                details?.postComments?.map((comment) => ({ content: comment.content, username: comment.posterName })) ||
                [],
              statistics: {
                reactions: details?.reactions,
                comments: details?.comments,
                shares: details?.shares,
                reach: details?.adImpressions
              },
              info: {
                name: details?.pageName,
                avatar: details?.avatar,
                followers: details?.subscribers
              }
            }
          : undefined
      }
    />
  );
};
